.productList {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.viewMoreRow {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.arrowIcon {
  margin-left: 4px;
  width: 16px;
  height: 16px;
}

@media (--view-sm) {
  .productList {
    grid-template-columns: repeat(4, 1fr);
  }
  .viewMoreRow {
    margin-top: 24px;
  }
}
